import React, { useRef, useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { ref, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../../utils/firebase';
import './Scroll.css';

const Balsa360 = () => {
  const panoramaRef = useRef(null);
  const [panoramaUrl, setPanoramaUrl] = useState('');
  const [currentImage, setCurrentImage] = useState('images_1');
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - panoramaRef.current.offsetLeft);
    setScrollLeft(panoramaRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - panoramaRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    panoramaRef.current.scrollLeft = scrollLeft - walk;
  };

  // Touch Handlers for Mobile Devices
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - panoramaRef.current.offsetLeft);
    setScrollLeft(panoramaRef.current.scrollLeft);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.touches[0].pageX - panoramaRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    panoramaRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  const fetchImage = async (imageField) => {
    try {
      const imagesRef = collection(db, '360_images');
      const q = query(imagesRef, where('title', '==', 'Kainan sa Balsa'));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const docData = querySnapshot.docs[0].data();
        const imagePath = docData[imageField];
        const imageRef = ref(storage, imagePath);
        const url = await getDownloadURL(imageRef);
        setPanoramaUrl(url);
      } else {
        console.error('No document found with the title "Kainan sa Balsa"');
      }
    } catch (error) {
      console.error('Error fetching panorama image:', error);
    }
  };

  const toggleImage = () => {
    const nextImage = currentImage === 'images_1' ? 'images_3' : 'images_1';
    setCurrentImage(nextImage);
  };

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      panoramaRef.current.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(document.fullscreenElement === panoramaRef.current);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    fetchImage(currentImage);
  }, [currentImage]);

  return (
    <div>
      
      <div
        className="panorama-container"
        ref={panoramaRef}
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <img
          src={panoramaUrl}
          alt="Strike Gymnasium Panorama"
          className="panorama-image"
        />
        <button className="fullscreen-button" onClick={toggleFullscreen}>
          <i className="bi bi-fullscreen"></i>
        </button>
      </div>
      <div className="button-container">
        <button className="toggle-button" onClick={toggleImage}>
          {currentImage === 'images_1' ? 'View Next Image' : 'View Previous Image'}
        </button>
      </div>
    </div>
  );
};

export default Balsa360;
